export type LocaleValue = string | string[];

export const LOCALE_BY_COUNTRY: Record<string, LocaleValue> = {
    ES: 'es',
    PT: 'pt-pt',
    IT: 'it-it',
    FR: 'fr-fr',
    BE: ['fr-be', 'nl-be'],
    GB: 'en-gb',
    IR: 'en-ie',
    DE: 'de',
    AT: 'de-at',
    SE: 'sv-se',
    DK: 'da-dk',
    NO: 'no-no',
    CZ: 'cs-cz',
    CH: ['de-ch', 'it-ch', 'fr-ch'],
    FI: 'fi-fi',
    HU: 'hu-hu',
    NL: 'nl-nl',
    PL: 'pl-pl',
    LT: 'lt-lt',
    LV: 'lv-lv',
    EE: 'et-ee',
    LU: 'fr-lu',
    HR: 'hr-hr',
    SI: 'sl-sl',
    SK: 'sk-sk',
    US: 'usa',
    CA: ['en-ca', 'fr-ca'],
    NZ: 'en-nz',
    SG: 'en-sg',
    ZA: 'en-za',
    TR: 'tr-tr',
    AE: 'en-ae',
    IL: 'he-il',
    MY: 'en-my',
    MX: 'es-mx',
    CO: 'es',
    AR: 'es',
    CL: 'es',
    BR: 'pt-br',
    JP: 'ja-jp',
    AU: 'en-au',
};

/**
 * Mapeado específico para la Visita Virtual (news n3).
 * Valores exactamente como los necesita el parámetro language (ej. 'en_GB', 'es', 'fr', ...)
 */
export const VISIT_LOCALE_BY_COUNTRY: Record<string, string | string[]> = {
    ES: 'es',
    PT: 'pt_PT',
    IT: 'it',
    FR: 'fr',
    BE: ['fr_BE', 'nl_BE'],
    GB: 'en_GB',
    IR: 'en_IE',
    DE: 'de',
    AT: 'de_AT',
    SE: 'sv',
    DK: 'da',
    NO: 'no',
    CZ: 'cs-cz',
    CH: ['de_CH', 'it_CH', 'fr_CH'],
    FI: 'fi',
    HU: 'hu',
    NL: 'nl_NL',
    PL: 'pl',
    LT: 'en_GB',
    LV: 'en_GB',
    EE: 'en_GB',
    LU: 'fr_LU',
    SI: 'en_GB',
    SK: 'sk',
    US: 'en_US',
    CA: ['en_CA', 'fr_CA'],
    NZ: 'en_GB',
    SG: 'en_SG',
    ZA: 'en_ZA',
    TR: 'tr',
    AE: 'ar_AE',
    IL: 'iw',
    MY: 'en_MY',
    MX: 'es_MX',
    CO: 'es',
    AR: 'es',
    CL: 'es',
    BR: 'pt_BR',
    JP: 'en_GB',
    AU: 'en_AU',
};

type ProductConfig = {
    template?: 'generic' | 'root' | string;
    urlAbsolute?: string;
    perCountryOverride?: Record<string, string>;
};

export const PRODUCT_MAP: Record<string, ProductConfig> = {
    suma: { template: 'generic' },
    sensa: { template: 'root' },
    pietrakode: { template: 'https://www.cosentino.com/{locale}/dekton/{slug}/' },
    'le-chic': { template: 'generic' },
    ukiyo: { template: 'generic' },
    blog: {
        template:
        'https://www.cosentino.com/{locale}/blog/?spaces=&project-type=&uses=&brands=&content-typology=interviews&styles=&country=&search=&extra=&sort=date',
    },
    vanities: {
        perCountryOverride: {
            ES: 'https://www.cosentino.com/es/silestone/lavabos/',
            PT: 'https://www.cosentino.com/pt-pt/silestone/lavatorios/',
            IT: 'https://www.cosentino.com/it-it/silestone/vanity/',
            FR: 'https://www.cosentino.com/fr-fr/silestone/vasques/',
            'fr-be': 'https://www.cosentino.com/fr-be/silestone/vasques/',
            'nl-be': 'https://www.cosentino.com/nl-be/silestone/silestone-wastafels/',
            BE: 'https://www.cosentino.com/fr-be/silestone/vasques/',    
            GB: 'https://www.cosentino.com/en-gb/silestone/vanities/',
            IR: 'https://www.cosentino.com/en-ie/silestone/vanities/',              
            DE: 'https://www.cosentino.com/de/silestone/wandschraenke/',
            AT: 'https://www.cosentino.com/de-at/silestone/wandschraenke/',
            SE: 'https://www.cosentino.com/sv-se/silestone/vanities/',
            DK: 'https://www.cosentino.com/da-dk/silestone/vanities/',
            NO: 'https://www.cosentino.com/no-no/silestone/vaskeservanter/',
            CZ: 'https://www.cosentino.com/cs-cz/silestone/toaletni-skrinky/',
            'de-ch': 'https://www.cosentino.com/de-ch/silestone/wandschraenke/',
            'it-ch': 'https://www.cosentino.com/it-ch/silestone/vanity/',
            'fr-ch': 'https://www.cosentino.com/fr-ch/silestone/vasques/',
            CH: 'https://www.cosentino.com/de-ch/silestone/wandschraenke/',
            FI: 'https://www.cosentino.com/fi-fi/silestone/pesualtaat/',
            HU: 'https://www.cosentino.com/hu-hu/silestone/mosdopultok/',
            NL: 'https://www.cosentino.com/nl-nl/silestone/silestone-wastafels/',
            PL: 'https://www.cosentino.com/pl-pl/silestone/vanities/',
            LT: 'https://www.cosentino.com/lt-lt/silestone/praustuvai/',
            LV: 'https://www.cosentino.com/lv-lv/silestone/vanities/',
            EE: 'https://www.cosentino.com/et-ee/silestone/vanities/',
            LU: 'https://www.cosentino.com/fr-lu/silestone/vasques/',
            SI: 'https://www.cosentino.com/sl-sl/silestone/toaletne-mizice/',
            SK: 'https://www.cosentino.com/sk-sk/silestone/kupelnove-doplnky/',
            US: 'https://www.cosentino.com/usa/silestone/bathroom-sinks/',
            'fr-ca': 'https://www.cosentino.com/fr-ca/silestone/vasques/',
            'en-ca': 'https://www.cosentino.com/en-ca/silestone/vanities/',
            CA: 'https://www.cosentino.com/en-ca/silestone/vanities/',   
            NZ: 'https://www.cosentino.com/en-nz/silestone/vanities/',
            SG: 'https://www.cosentino.com/en-sg/silestone/vanities/',
            ZA: 'https://www.cosentino.com/en-za/silestone/vanities/',
            TR: 'https://www.cosentino.com/tr-tr/silestone/lavabolar/',
            AE: 'https://www.cosentino.com/en-ae/silestone/vanities/',
            IL: 'https://www.cosentino.com/he-il/silestone/vanities/',
            MY: 'https://www.cosentino.com/en-my/silestone/vanities/',
            MX: 'https://www.cosentino.com/es-mx/silestone/lavabos/',
            CO: 'https://www.cosentino.com/latam/inspiration/galleries/',     
            AR: 'https://www.cosentino.com/latam/inspiration/galleries/',
            CL: 'https://www.cosentino.com/latam/inspiration/galleries/',
            BR: 'https://www.cosentino.com/pt-br/silestone/vaidades/',
            JP: 'https://www.cosentino.com/ja-jp/silestone/vanities/',
            AU: 'https://www.cosentino.com/en-au/silestone/vanities/',
            DEFAULT: 'https://www.cosentino.com/silestone/vanities/'
        }
    },
    galleries: {
        perCountryOverride: {
            ES: 'https://www.cosentino.com/es/inspiracion/galerias/',
            PT: 'https://www.cosentino.com/pt-pt/inspiracao/galerias/',
            IT: 'https://www.cosentino.com/it-it/ispirazione/gallerie/',
            FR: 'https://www.cosentino.com/fr-fr/inspiration/galeries/',
            BE: 'https://www.cosentino.com/fr-be/inspiration/galeries/',       
            GB: 'https://www.cosentino.com/en-gb/inspiration/galleries/',
            IE: 'https://www.cosentino.com/en-ie/inspiration/galleries/',
            DE: 'https://www.cosentino.com/de/inspiration/galerien/',
            AT: 'https://www.cosentino.com/de-at/inspiration/galerien/',
            SE: 'https://www.cosentino.com/sv-se/inspiration/galleries/',
            DK: 'https://www.cosentino.com/da-dk/inspiration/galleries/',
            NO: 'https://www.cosentino.com/no-no/inspiration/gallerier/',
            CZ: 'https://www.cosentino.com/cs-cz/inspiration/galleries/',
            CH: 'https://www.cosentino.com/de-ch/inspiration/galerien/',        
            FI: 'https://www.cosentino.com/fi-fi/inspiraatiota/galleriat/',
            HU: 'https://www.cosentino.com/hu-hu/inspiration/galleries/',
            NL: 'https://www.cosentino.com/nl-nl/inspiratie/galerijen/',
            PL: 'https://www.cosentino.com/pl-pl/inspiration/galleries/',
            LT: 'https://www.cosentino.com/lt-lt/inspiration/galleries/',
            LV: 'https://www.cosentino.com/lv-lv/inspiration/galleries/',
            EE: 'https://www.cosentino.com/et-ee/inspiration/galleries/',
            LU: 'https://www.cosentino.com/fr-lu/inspiration/galeries/',
            SI: 'https://www.cosentino.com/sl-sl/inspiration/galleries/',
            SK: 'https://www.cosentino.com/sk-sk/inspiration/galleries/',
            US: 'https://www.cosentino.com/usa/inspiration/galleries/',
            CA: 'https://www.cosentino.com/en-ca/inspiration/galleries/',      
            NZ: 'https://www.cosentino.com/en-nz/inspiration/galleries/',
            SG: 'https://www.cosentino.com/en-sg/inspiration/galleries/',
            ZA: 'https://www.cosentino.com/en-za/inspiration/galleries/',
            TR: 'https://www.cosentino.com/tr-tr/inspiration/galleries/',
            AE: 'https://www.cosentino.com/en-ae/inspiration/galleries/',
            IL: 'https://www.cosentino.com/he-il/inspiration/galleries/',
            MY: 'https://www.cosentino.com/en-my/inspiration/galleries/',
            MX: 'https://www.cosentino.com/es-mx/inspiration/galleries/',
            CO: 'https://www.cosentino.com/es/inspiracion/galerias/',
            AR: 'https://www.cosentino.com/es/inspiracion/galerias/',
            CL: 'https://www.cosentino.com/es/inspiracion/galerias/',
            BR: 'https://www.cosentino.com/pt-br/inspiration/galleries/',
            JP: 'https://www.cosentino.com/ja-jp/inspiration/galleries/',
            AU: 'https://www.cosentino.com/en-au/inspiration/galleries/',
            // locale-variants keys to support userLang resolution
            'fr-be': 'https://www.cosentino.com/fr-be/inspiration/galeries/',
            'nl-be': 'https://www.cosentino.com/nl-be/inspiratie/galerijen/',
            'it-ch': 'https://www.cosentino.com/it-ch/ispirazione/gallerie/',
            'de-ch': 'https://www.cosentino.com/de-ch/inspiration/galerien/',
            'fr-ch': 'https://www.cosentino.com/fr-ch/inspiration/galeries/',
            'fr-ca': 'https://www.cosentino.com/fr-ca/inspiration/galleries/',
            'en-ca': 'https://www.cosentino.com/en-ca/inspiration/galleries/',
            DEFAULT: 'https://www.cosentino.com/inspiration/galleries/'
        }
    },
    kitchenVisualizer: {
        perCountryOverride: {
            ES: 'https://www.cosentino.com/es/visualizador-cocina/',
            GB: 'https://www.cosentino.com/en-gb/kitchen-visualizer/',
            US: 'https://www.cosentino.com/usa/kitchen-visualizer/',
            DEFAULT: 'https://www.cosentino.com/en-gb/kitchen-visualizer/'
        }
    },
    bathroomVisualizer: {
        perCountryOverride: {
            ES: 'https://www.cosentino.com/es/visualizador-bano/',
            GB: 'https://www.cosentino.com/en-gb/bathroom-visualizer/',
            US: 'https://www.cosentino.com/usa/bathroom-visualizer/',
            DEFAULT: 'https://www.cosentino.com/en-gb/bathroom-visualizer/'
        }
    }
};

/**
 * Normaliza userLang -> devuelve la parte del idioma en minúsculas ('fr' de 'fr-FR' o 'fr-be')
 */
function extractLanguagePart(userLang?: string): string | undefined {
    if (!userLang) return undefined;
    return userLang.split(/[-_]/)[0].toLowerCase();
}

/**
 * Devuelve la lista de locales aplicables para countryCode en orden de preferencia.
 */
export function getLocaleCandidates(countryCode?: string, fallback = 'es'): string[] {
    if (!countryCode) return [fallback];
    const v = LOCALE_BY_COUNTRY[countryCode.toUpperCase()];
    if (!v) return [fallback];
    return Array.isArray(v) ? v : [v];
}

/**
 * Dado countryCode y userLang, intenta seleccionar el locale más adecuado.
 * - Si el país tiene varias variantes, intenta emparejar por userLang primero.
 * - Si no hay match, devuelve el primer candidato.
 */
export function selectLocaleForCountry(countryCode?: string, userLang?: string, fallback = 'es'): string {
    const candidates = getLocaleCandidates(countryCode, fallback);
    if (candidates.length === 1) return candidates[0];

    const lang = extractLanguagePart(userLang);
    if (!lang) return candidates[0];

    // busca coincidencia por prefijo de idioma en cada candidate (e.g. 'fr' -> 'fr-be', 'fr-ch')
    const match = candidates.find(c => c.toLowerCase().startsWith(lang + '-') || c.toLowerCase() === lang);
    if (match) return match;

    // también intenta emparejar si userLang completo coincide (e.g. 'fr-be' -> 'fr-be')
    const fullMatch = candidates.find(c => c.toLowerCase() === userLang?.toLowerCase());
    if (fullMatch) return fullMatch;

    return candidates[0];
}

/**
 * Extrae la parte de idioma corta (ej 'fr' de 'fr-FR' o 'fr_BE') para matching.
 */
function extractLangPart(userLang?: string): string | undefined {
    if (!userLang) return undefined;
    return userLang.split(/[-_]/)[0].toLowerCase();
}

/**
 * Devuelve la lista de candidatos para un countryCode en VISIT_LOCALE_BY_COUNTRY.
 */
function getVisitLocaleCandidates(countryCode?: string, fallback = 'en_GB'): string[] {
    if (!countryCode) return [fallback];
    const v = VISIT_LOCALE_BY_COUNTRY[countryCode.toUpperCase()];
    if (!v) return [fallback];
    return Array.isArray(v) ? v : [v];
}

/**
 * Selecciona el locale para la visita virtual intentando casar userLang con variantes (BE, CH, CA).
 */
export function selectVisitLocale(countryCode?: string, userLang?: string, fallback = 'en_GB'): string {
    const candidates = getVisitLocaleCandidates(countryCode, fallback);
    if (candidates.length === 1) return candidates[0];

    const lang = extractLangPart(userLang);
    if (!lang) return candidates[0];

    // intenta prefijo ('fr' -> 'fr_BE') o coincidencia exacta
    const match = candidates.find(c => c.toLowerCase().startsWith(lang + '_') || c.toLowerCase().startsWith(lang + '-'));
    if (match) return match;

    const fullMatch = candidates.find(c => c.toLowerCase() === (userLang ?? '').toLowerCase());
    if (fullMatch) return fullMatch;

    return candidates[0];
}

/**
 * Nuevo helper: intenta resolver perCountryOverride teniendo en cuenta userLang.
 * - cfg.perCountryOverride puede contener claves: countryCode (BE), locale (fr-be) o compuestas (FR-BE)
 * - Prioridad:
 *   1. buscar por locale seleccionado (ej. 'fr-be' / 'nl-be')
 *   2. buscar por la clave countryCode (ej. 'BE')
 *   3. buscar por 'DEFAULT'
 */
function resolvePerCountryOverride(
        perCountryOverride: Record<string, string> | undefined,
        countryCode: string | undefined,
        userLang?: string
    ): string | undefined {
    if (!perCountryOverride || !countryCode) return undefined;
    const cc = countryCode.toUpperCase();

    // 1) intentar matching por locale variante basado en userLang
    const candidates = getLocaleCandidates(cc);
    if (candidates.length > 0) {
        // selecciona la variante que mejor coincide con userLang (si userLang definido)
        if (userLang) {
        const lang = extractLanguagePart(userLang);
        if (lang) {
            // buscar exact match por locale que empiece por lang (ej 'fr' -> 'fr-be')
            const localeMatch = candidates.find(c => c.toLowerCase().startsWith(lang + '-') || c.toLowerCase() === lang);
            if (localeMatch) {
            // comprobar si override contiene clave con ese locale en distintos formatos
            const keysToTry = [
                localeMatch,                   // 'fr-be' (normal)
                localeMatch.toUpperCase(),     // 'FR-BE'
                localeMatch.replace('-', '_'), // 'fr_be' (si tus claves usan underscore)
            ];
            for (const k of keysToTry) {
                if (perCountryOverride[k]) return perCountryOverride[k];
            }
            }
        }

        // buscar full userLang match (ej 'fr-BE' o 'fr_BE')
        const normalizedUserLangs = [userLang, userLang.replace('-', '_')].map(s => s?.toLowerCase());
        for (const cand of Object.keys(perCountryOverride)) {
            const low = cand.toLowerCase();
            if (normalizedUserLangs.includes(low)) return perCountryOverride[cand];
        }
        }

        // 2) si no hubo match por userLang intenta buscar por locale candidates sin userLang
        for (const locale of candidates) {
        if (perCountryOverride[locale]) return perCountryOverride[locale];
        if (perCountryOverride[locale.toUpperCase()]) return perCountryOverride[locale.toUpperCase()];
        if (perCountryOverride[locale.replace('-', '_')]) return perCountryOverride[locale.replace('-', '_')];
        }
    }

    // 3) intentar clave por country code directa (BE, CH, CA)
    if (perCountryOverride[cc]) return perCountryOverride[cc];

    // 4) fallback DEFAULT
    if (perCountryOverride['DEFAULT']) return perCountryOverride['DEFAULT'];

    return undefined;
}

/**
 * Construye la URL para un producto y un locale dado.
 */
export function buildUrlForLocale(locale: string, slug: string, cfg?: ProductConfig): string {
    const normalized = locale.replace(/^\/+|\/+$/g, '');
    if (cfg?.urlAbsolute) return cfg.urlAbsolute;
    const template = cfg?.template ?? 'generic';

    if (template === 'generic') {
        return `https://www.cosentino.com/${normalized}/silestone/${slug}/`;
    }
    if (template === 'root') {
        return `https://www.cosentino.com/${normalized}/${slug}/`;
    }
    return template.replace(/\{locale\}/g, normalized).replace(/\{slug\}/g, slug);
}

/**
 * API principal: construye la URL usando la locale seleccionada en base a countryCode + userLang.
 */
export function buildProductUrl(countryCode: string | undefined, slug: string, userLang?: string, fallback = 'es'): string {
    const cc = (countryCode ?? '').toUpperCase();
    const cfg = PRODUCT_MAP[slug] ?? { template: 'generic' };

    // 1) si hay perCountryOverride, intentar resolver teniendo en cuenta userLang y variantes
    const override = resolvePerCountryOverride(cfg.perCountryOverride, cc, userLang);
    if (override) return override;

    // 2) si existe urlAbsolute
    if (cfg.urlAbsolute) return cfg.urlAbsolute;

    // 3) selección de locale primaria basada en userLang si hay varias
    const locale = selectLocaleForCountry(cc, userLang, fallback);
    return buildUrlForLocale(locale, slug, cfg);
}

/**
 * Construye la URL final para la Visita Virtual con el query param language.
 * Ejemplos:
 *  - https://we.cosentino.com/s/form-onlinevisit?language=en_GB
 *  - https://we.cosentino.com/s/form-onlinevisit?language=es
 */
export function buildVisitFormUrl(countryCode: string | undefined, userLang?: string, fallback = 'en_GB'): string {
    const locale = selectVisitLocale(countryCode, userLang, fallback);
    const base = 'https://we.cosentino.com/s/form-onlinevisit';
    const encoded = encodeURIComponent(locale);
    return `${base}?language=${encoded}`;
}

/**
 * Devuelve todas las URLs candidatas (para pruebas/CI) teniendo en cuenta las variantes locales.
 */
export function buildAllProductUrlsForCountry(countryCode: string | undefined, slug: string, fallback = 'es'): string[] {
    const cc = (countryCode ?? '').toUpperCase();
    const cfg = PRODUCT_MAP[slug] ?? { template: 'generic' };
    if (cfg.perCountryOverride?.[cc]) return [cfg.perCountryOverride[cc]];
    const locales = getLocaleCandidates(cc, fallback);
    return locales.map(locale => buildUrlForLocale(locale, slug, cfg));
}

export function buildAppointmentUrl(countryCode: string | undefined, userLang?: string): string | undefined {
  const cc = countryCode?.toUpperCase();
  const lang = userLang?.toLowerCase() ?? '';

  if (cc === 'US' || cc === 'BR') {
    return 'https://www.cosentino.com/landings-usa/appointment/';
  }

  if (cc === 'CA') {
    if (lang.includes('fr')) {
      return 'https://www.cosentino.com/landings-fr-fr/appointment/';
    }
    return 'https://www.cosentino.com/landings-usa/appointment/';
  }

  return undefined;
}

